<template>
  <a-drawer width="65%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose" :maskClosable="false">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <!-- 用户信息卡片 -->
      <a-card title="用户信息" style="margin-bottom: 16px;" :bordered="false">
        <a-row :gutter="24">
          <a-col :span="6">
            <div style="display: flex; align-items: center;">
              <img v-if="form.avatar" :src="processImageUrl(form.avatar)" style="width: 64px; height: 64px; border-radius: 50%; margin-right: 12px; border: 2px solid #1890ff;" />
              <div>
                <div style="font-size: 16px; font-weight: bold; color: #262626;">{{ form.nickname }}</div>
                <div style="color: #8c8c8c; font-size: 12px; margin-top: 4px;">{{ form.mobile }}</div>
              </div>
            </div>
          </a-col>
          <a-col :span="6">
            <div style="display: flex; flex-direction: column; justify-content: center; height: 64px;">
              <span style="color: #8c8c8c; font-size: 12px;">提现方式</span>
              <span style="font-size: 14px; font-weight: 500; color: #262626; margin-top: 4px;">
                <a-tag :color="form.type === 1 ? 'green' : 'blue'">
                  {{ form.type === 1 ? '微信提现' : '支付宝提现' }}
                </a-tag>
              </span>
            </div>
          </a-col>
          <a-col :span="6">
            <div style="display: flex; flex-direction: column; justify-content: center; height: 64px;">
              <span style="color: #8c8c8c; font-size: 12px;">提现类型</span>
              <span style="font-size: 14px; font-weight: 500; color: #262626; margin-top: 4px;">
                <a-tag :color="form.withdrawType === 1 ? 'blue' : 'purple'">
                  {{ form.withdrawType === 1 ? '积分提现' : form.withdrawType === 2 ? '现金提现' : '-' }}
                </a-tag>
              </span>
            </div>
          </a-col>
          <a-col :span="6">
            <div style="display: flex; flex-direction: column; justify-content: center; height: 64px;">
              <span style="color: #8c8c8c; font-size: 12px;">申请时间</span>
              <span style="font-size: 14px; font-weight: 500; color: #262626; margin-top: 4px;">{{ parseTime(form.createTime) }}</span>
            </div>
          </a-col>
        </a-row>
      </a-card>

      <!-- 提现信息卡片 -->
      <a-card title="提现信息" style="margin-bottom: 16px;" :bordered="false">
        <a-row :gutter="24">
          <a-col :span="8">
            <a-statistic
              title="提现积分"
              :value="form.money || 0"
              :precision="2"
              :value-style="{ color: '#1890ff' }"
            >
              <template #suffix>积分</template>
            </a-statistic>
          </a-col>
          <a-col :span="8">
            <a-statistic
              title="手续费用"
              :value="form.procedureCharge || 0"
              :precision="2"
              :value-style="{ color: '#ff4d4f' }"
            >
              <template #suffix>积分</template>
            </a-statistic>
          </a-col>
          <a-col :span="8">
            <a-statistic
              title="到账金额"
              :value="form.arrivalAmount || 0"
              :precision="2"
              :value-style="{ color: '#52c41a' }"
            >
              <template #suffix>元</template>
            </a-statistic>
          </a-col>
        </a-row>
      </a-card>

      <!-- 审核状态 -->
      <a-card title="审核状态" style="margin-bottom: 16px;" :bordered="false">
        <a-form-model-item label="当前状态" prop="status">
          <a-select
            v-model="form.status"
            :disabled="isInfo == 2"
            placeholder="请选择审核状态"
            style="width: 100%;"
            @change="handleStatusChange"
          >
            <a-select-option value="0">待审核</a-select-option>
            <a-select-option value="1">审核通过</a-select-option>
            <a-select-option value="2">审核驳回</a-select-option>
          </a-select>
        </a-form-model-item>

        <a-form-model-item
          v-if="form.status == '2' || isInfo == 1"
          label="驳回原因"
          prop="reason"
          :rules="form.status == '2' ? [{ required: true, message: '驳回时必须填写驳回原因', trigger: 'blur' }] : []"
        >
          <a-textarea
            :disabled="isInfo == 2 && form.status != '-1'"
            v-model="form.reason"
            placeholder="请输入驳回原因,方便用户了解"
            :rows="4"
            :max-length="500"
            show-count
          />
        </a-form-model-item>

        <a-form-model-item label="审核备注" prop="remark">
          <a-textarea
            :disabled="isInfo == 2"
            v-model="form.remark"
            placeholder="请输入审核备注(选填)"
            :rows="3"
            :max-length="500"
            show-count
          />
        </a-form-model-item>
      </a-card>

      <!-- 凭证信息 -->
<!--      <a-card v-if="form.invoice" title="发票凭证" style="margin-bottom: 16px;" :bordered="false">-->
<!--        <div style="display: flex; flex-wrap: wrap; gap: 12px;">-->
<!--          <div v-for="(item, index) in form.invoice.split(',')" :key="index" style="position: relative;">-->
<!--            <img-->
<!--              v-viewer-->
<!--              :src="processImageUrl(item)"-->
<!--              style="height: 150px; width: 150px; border-radius: 8px; cursor: pointer; border: 1px solid #e8e8e8; object-fit: cover;"-->
<!--            />-->
<!--          </div>-->
<!--        </div>-->
<!--      </a-card>-->

      <!-- 底部操作栏 -->
      <div class="bottom-control" style="position: absolute; right: 0; bottom: 0; width: 100%; padding: 16px 24px; background: #fff; border-top: 1px solid #f0f0f0;">
        <a-space>
          <a-button v-if="this.isInfo == 1" type="primary" :loading="submitLoading" size="large" @click="submitForm">
            <a-icon type="check" />提交审核
          </a-button>
          <a-button @click="cancel" size="large">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getApply, addApply, updateApply, checkApply } from '@/api/withdraw/apply'
import { processImageUrl } from '@/utils/util'

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      isInfo:1,
      // 表单参数
      form: {
        id: null,
        userId: null,
        nickname: null,
        avatar: null,
        mobile: null,
        status: '0',
        type: null,
        withdrawType: null,
        procedureCharge: null,
        money: null,
        invoice: null,
        arrivalAmount: null,
        prove: null,
        reason: null,
        createTime: null,
        remark: null,
      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    processImageUrl,
    parseTime (time) {
      if (!time) return ''
      const date = new Date(time)
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      const hours = String(date.getHours()).padStart(2, '0')
      const minutes = String(date.getMinutes()).padStart(2, '0')
      const seconds = String(date.getSeconds()).padStart(2, '0')
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`
    },
    formatMoney (money) {
      if (!money) return '0'
      return money.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    // 状态改变处理
    handleStatusChange (value) {
      if (value === '2') {
        this.$nextTick(() => {
          this.$refs.form.validateField('reason')
        })
      }
    },
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        userId: null,
        nickname: null,
        avatar: null,
        mobile: null,
        status: '0',
        type: null,
        withdrawType: null,
        procedureCharge: null,
        money: null,
        invoice: null,
        arrivalAmount: null,
        prove: null,
        reason: null,
        createTime: null,
        remark: null,
      }
      this.$nextTick(() => {
        if(this.$refs.form){
          this.$refs.form.resetFields()
        }
      })
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      this.isInfo = 1
      const id = row ? row.id : ids
      getApply({"id":id}).then(response => {
        this.form = response.data
        // 将status转换为字符串类型，以便select正确显示
        if (this.form.status !== null && this.form.status !== undefined) {
          this.form.status = String(this.form.status)
        }
        this.open = true
        this.formTitle = '审核'
      })
    },
    handleInfo (row) {
      this.reset()
      this.formType = 2
      this.isInfo = 2
      getApply({"id":row.id}).then(response => {
        this.form = response.data
        // 将status转换为字符串类型，以便select正确显示
        if (this.form.status !== null && this.form.status !== undefined) {
          this.form.status = String(this.form.status)
        }
        this.open = true
        this.formTitle = '详情'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          // 如果选择了驳回,必须填写驳回原因
          if (this.form.status == '2' && !this.form.reason) {
            this.$message.warning('驳回时必须填写驳回原因')
            return false
          }
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            // 使用审核接口
            checkApply(this.form).then(response => {
              // 只有成功时才提示成功并关闭窗口
              this.$message.success('审核成功')
              this.open = false
              this.$emit('ok')
            }).catch(error => {
              // 错误已由 request.js 统一处理显示，这里只记录日志
              console.error('审核失败:', error)
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addApply(this.form).then(response => {
              this.$message.success('成功')
              this.open = false
              this.$emit('ok')
            }).catch(error => {
              console.error('添加失败:', error)
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
